import type { FileWithPath } from 'react-dropzone'

export const isZeroSize = (minFileSize?: number) => {
  return typeof minFileSize === 'number' && minFileSize <= 1
}

export const getFileDetail = (file: FileWithPath) => {
  return file.path || file.name
}
